import React from 'react';
import { Check, X } from 'lucide-react';

export const MemberComparisonTable = () => (
  <div className="mt-12">
    <h3 className="text-2xl font-bold text-center mb-6">Tableau Comparatif Complet</h3>
    <div className="overflow-x-auto">
      <table className="w-full border-collapse bg-white rounded-lg shadow-lg">
        <thead>
          <tr className="bg-gradient-to-r from-blue-600 to-purple-600 text-white">
            <th className="p-4 text-left font-semibold">Fonctionnalité</th>
            <th className="p-4 text-center font-semibold">Essentiel</th>
            <th className="p-4 text-center font-semibold bg-blue-700">Pro</th>
            <th className="p-4 text-center font-semibold bg-purple-700">Premium</th>
          </tr>
        </thead>
        <tbody>
          {[
            { feature: 'Prix mensuel', essentiel: '19€', pro: '49€', premium: '99€' },
            { feature: 'Crédits inclus', essentiel: '5/mois', pro: '30/mois', premium: '120/mois' },
            { feature: 'Coût net réel', essentiel: '19€', pro: '19€', premium: '-21€ (gain!)' },
            { feature: 'Déclaration dommage', essentiel: '48-72h', pro: '24-48h ⚡', premium: '12-24h ⚡⚡' },
            { feature: 'Réduction dispositifs', essentiel: '–', pro: '-15%', premium: '-15%' },
            { feature: 'Attestations prioritaires', essentiel: false, pro: true, premium: true },
            { feature: 'Assistance admin', essentiel: false, pro: true, premium: true },
            { feature: 'Expertise accélérée', essentiel: false, pro: false, premium: true },
            { feature: 'Médiation incluse', essentiel: false, pro: false, premium: true },
            { feature: 'Audit dossiers', essentiel: false, pro: false, premium: '✅ Illimité' },
            { feature: 'Hotline dédiée', essentiel: false, pro: false, premium: true },
          ].map((row, idx) => (
            <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
              <td className="p-4 font-medium text-gray-700">{row.feature}</td>
              <td className="p-4 text-center">
                {typeof row.essentiel === 'boolean' ? (
                  row.essentiel ? <Check className="h-5 w-5 text-green-600 mx-auto" /> : <X className="h-5 w-5 text-gray-300 mx-auto" />
                ) : (<span className="text-sm">{row.essentiel}</span>)}
              </td>
              <td className="p-4 text-center bg-blue-50">
                {typeof row.pro === 'boolean' ? (
                  row.pro ? <Check className="h-5 w-5 text-green-600 mx-auto" /> : <X className="h-5 w-5 text-gray-300 mx-auto" />
                ) : (<span className="text-sm font-medium">{row.pro}</span>)}
              </td>
              <td className="p-4 text-center bg-purple-50">
                {typeof row.premium === 'boolean' ? (
                  row.premium ? <Check className="h-5 w-5 text-green-600 mx-auto" /> : <X className="h-5 w-5 text-gray-300 mx-auto" />
                ) : (<span className="text-sm font-medium">{row.premium}</span>)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export const ConseillerComparisonTable = () => (
  <div className="mt-12">
    <h3 className="text-2xl font-bold text-center mb-6">Tableau Comparatif Conseillers</h3>
    <div className="overflow-x-auto">
      <table className="w-full border-collapse bg-white rounded-lg shadow-lg">
        <thead>
          <tr className="bg-gradient-to-r from-green-600 to-teal-600 text-white">
            <th className="p-4 text-left font-semibold">Fonctionnalité</th>
            <th className="p-4 text-center font-semibold">Gratuit</th>
            <th className="p-4 text-center font-semibold bg-green-700">ESS+</th>
            <th className="p-4 text-center font-semibold bg-teal-700">ESS PRO</th>
          </tr>
        </thead>
        <tbody>
          {[
            { feature: 'Prix', gratuit: '0€', essPlus: '29€/mois', essPro: '79€/mois' },
            { feature: 'Crédits inclus', gratuit: '0', essPlus: '10/mois', essPro: '50/mois' },
            { feature: 'Coût net réel', gratuit: '0€', essPlus: '29€', essPro: '29€' },
            { feature: 'Accès leads publics', gratuit: false, essPlus: true, essPro: '✅ Prioritaire' },
            { feature: 'Messagerie complète', gratuit: 'Basique', essPlus: true, essPro: true },
            { feature: 'Outils avancés', gratuit: false, essPlus: true, essPro: true },
            { feature: 'CRM intégré', gratuit: false, essPlus: false, essPro: true },
            { feature: 'Modèles premium', gratuit: false, essPlus: false, essPro: true },
            { feature: 'Badge certifié', gratuit: false, essPlus: false, essPro: true },
            { feature: 'Profil prioritaire', gratuit: false, essPlus: false, essPro: true },
          ].map((row, idx) => (
            <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
              <td className="p-4 font-medium text-gray-700">{row.feature}</td>
              <td className="p-4 text-center">
                {typeof row.gratuit === 'boolean' ? (
                  row.gratuit ? <Check className="h-5 w-5 text-green-600 mx-auto" /> : <X className="h-5 w-5 text-gray-300 mx-auto" />
                ) : (<span className="text-sm">{row.gratuit}</span>)}
              </td>
              <td className="p-4 text-center bg-green-50">
                {typeof row.essPlus === 'boolean' ? (
                  row.essPlus ? <Check className="h-5 w-5 text-green-600 mx-auto" /> : <X className="h-5 w-5 text-gray-300 mx-auto" />
                ) : (<span className="text-sm font-medium">{row.essPlus}</span>)}
              </td>
              <td className="p-4 text-center bg-teal-50">
                {typeof row.essPro === 'boolean' ? (
                  row.essPro ? <Check className="h-5 w-5 text-green-600 mx-auto" /> : <X className="h-5 w-5 text-gray-300 mx-auto" />
                ) : (<span className="text-sm font-medium">{row.essPro}</span>)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
